const questions = {
  welcomeData: {
    title: "Scopri le birre perfette per te!",
    description: "Non serve essere un esperto per innamorarti della birra artigianale: \nTu fai il quiz, noi troviamo le birre perfette per te!",
    button: "Inizia!",
  },
  questionData: [
    {
      id: 1,
      title: "⁠Che sapore preferisci in una birra?",
      description: "",
      questions: [
        "Tendenzialmente amaro \n(es. IPA, APA)",
        "Tendenzialmente dolce \n(es. Belgian Ale, Dubbel)",
        "Tostato scuro \n(es. Stout, Porter)",
        "Chiare e leggere \n(es. Lager, Pilsner, Blanche)",
        "Nessuna preferenza specifica \n (aperto a qualsiasi stile)",
      ],
    },
    {
      id: 2,
      title: "Che tipo di selezione di birre stai cercando?",
      description: "",
      questions: [
        "Selezione mista di stili (per esplorare) – \n Voglio assaggiare un po’ di tutto, con diverse tipologie di birre.",
        "Selezione focalizzata su uno stile – \n Voglio approfondire un solo tipo di birra che già so di apprezzare.",
        "È un regalo per qualcun altro – \n Sto cercando una box da regalare a un amico o familiare appassionato."
      ],
    },
    {
      id: 3,
      title: "Hai preferenze o esigenze particolari?",
      description: "",
      questions: [
        "No, nessuna esigenza particolare (qualsiasi birra va bene).",
        "Sì, preferisco solo birre senza glutine.",
        "Sì, preferisco solo birre analcoliche."
      ],
    }
  ],
};

const outputBody = document.getElementById("quiz");

//* Destructuring the questions object
const { welcomeData, resultData, questionData } = questions;

//* Selected items
let selectedItems = [];
let itemsIndex = [];

function welcomeScreen(title = welcomeData?.title, description = welcomeData.description, buttonText = welcomeData.button) {
    if (outputBody) {
        
        outputBody.innerHTML = "";

        // Create elements
        const welcomeDiv = document.createElement("div");
        const h1 = document.createElement("h1");
        const p = document.createElement("p");
        const button = document.createElement("button");

        // Add classes or IDs
        welcomeDiv.classList.add("benvenuto");
        h1.classList.add("titolo");
        p.classList.add("descrizione");
        button.id = "iniziaQuiz";

        // Add text
        h1.innerText = title;
        p.innerText = description;
        button.innerText = buttonText;

        // Append elements
        welcomeDiv.appendChild(h1);
        welcomeDiv.appendChild(p);
        welcomeDiv.appendChild(button);

        // Append to question App
        outputBody.appendChild(welcomeDiv);

        // Add event listener
        button.addEventListener("click", function (event) {
            welcomeDiv.classList.add("hide");
            questionOne();
            window.scrollTo(0,0);
        });
    }
}

function questionOne(title = questionData[0]?.title, description = questionData[0]?.description) {
    if (outputBody) {
        // Create elements
        const questionDiv = document.createElement("div");
        questionDiv.classList.add("domande", "domanda-1");

        const h2 = document.createElement("h2");
        const p = document.createElement("p");

        const questionsList = document.createElement("ul");

        const buttonWrapper = document.createElement("div");
        const prevBtn = document.createElement("button");
        const nextBtn = document.createElement("button");

        // Add classes or IDs
        h2.classList.add("titolo-domanda");
        p.classList.add("descrizione-domanda");
        questionsList.classList.add("elenco-domande");
        buttonWrapper.classList.add("contenitore-domande");
        prevBtn.id = "domandaPrecedente";
        nextBtn.id = "domandaSuccessiva";
        nextBtn.disabled = true;
        nextBtn.classList.add("disabled");

        // Add text
        h2.innerText = title === "" ? "Nessun titolo!" : title;
        p.innerText = description === "" ? "" : description;
        prevBtn.innerText = "Inizio";
        nextBtn.innerText = "Avanti";

        // Append elements
        questionDiv.appendChild(h2);
        questionDiv.appendChild(p);

        // Loop through the questions and add them to the list
        for (let i = 0; i < questionData[0].questions.length; i++) {
            const li = document.createElement("li");
            li.innerText = questionData[0].questions[i];
            questionsList.appendChild(li);
        }

        buttonWrapper.appendChild(prevBtn);
        buttonWrapper.appendChild(nextBtn);
        questionDiv.appendChild(questionsList);
        questionDiv.appendChild(buttonWrapper);

        // Append to question App
        outputBody.appendChild(questionDiv);

        // Add event listener
        // TODO: Add event listener to the list items
        const listItems = document.querySelectorAll(".domanda-1 .elenco-domande li");

        listItems.forEach((item, pos) => {
            item.addEventListener("click", function (event) {
                listItems.forEach((item) => item.classList.remove("active"));

                item.classList.add("active");

                selectedItems.splice(0, 1);
                selectedItems.push(event.target.innerText);

                itemsIndex.splice(0, 1);
                itemsIndex.push(pos);

                if (selectedItems.length > 0) {
                    nextBtn.disabled = false;
                    nextBtn.classList.remove("disabled");
                }
                
            });
        });

        prevBtn.addEventListener("click", function (event) {
            selectedItems.splice(0, 1);

            itemsIndex.splice(0, 1);
            // console.log(itemsIndex);

            questionDiv.classList.add("hide");
            welcomeScreen();
        });

        nextBtn.addEventListener("click", function (event) {
            if (selectedItems.length < 1) {
                return;
            }
            questionDiv.classList.add("hide");
            questionTwo();
            window.scrollTo(0,0);
        });
    }
}

function questionTwo(title = questionData[1]?.title, description = questionData[1]?.description) {
    if (outputBody) {
        const question1 = document.querySelector(".domanda-1");
        if (question1) {
            question1.remove();
        }

        const questionDiv = document.createElement("div");
        questionDiv.classList.add("domande", "domanda-2");
        const h2 = document.createElement("h2");
        const p = document.createElement("p");
        const questionsList = document.createElement("ul");

        const buttonWrapper = document.createElement("div");
        const prevBtn = document.createElement("button");
        const nextBtn = document.createElement("button");

        // Add classes or IDs
        h2.classList.add("titolo-domanda");
        p.classList.add("descrizione-domanda");
        questionsList.classList.add("elenco-domande");
        buttonWrapper.classList.add("contenitore-domande");
        prevBtn.id = "domandaPrecedente";
        nextBtn.id = "domandaSuccessiva";
        nextBtn.disabled = true;
        nextBtn.classList.add("disabled");

        // Add text
        h2.innerText = title === "" ? "Nessun titolo!" : title;
        p.innerText = description === "" ? "" : description;
        prevBtn.innerText = "Indietro";
        nextBtn.innerText = "Avanti";

        // Append elements
        questionDiv.appendChild(h2);
        questionDiv.appendChild(p);

        for (let i = 0; i < questionData[1].questions.length; i++) {
            const li = document.createElement("li");
            li.innerText = questionData[1].questions[i];
            questionsList.appendChild(li);
        }

        buttonWrapper.appendChild(prevBtn);
        buttonWrapper.appendChild(nextBtn);
        questionDiv.appendChild(questionsList);
        questionDiv.appendChild(buttonWrapper);

        // Append to question App
        outputBody.appendChild(questionDiv);

        // Add event listener
        const listItems = document.querySelectorAll(".domanda-2 .elenco-domande li");
        

        listItems.forEach((item, pos) => {
            item.addEventListener("click", function (event) {
                listItems.forEach((item) => item.classList.remove("active"));

                item.classList.add("active");

                selectedItems.splice(1, 1);
                selectedItems.push(event.target.innerText);

                itemsIndex.splice(1, 1);
                itemsIndex.push(pos);

                if (selectedItems.length > 1) {
                    nextBtn.disabled = false;
                    nextBtn.classList.remove("disabled");
                }
            });
        });

        prevBtn.addEventListener("click", function (event) {
            selectedItems.splice(1, 1);
            itemsIndex.splice(1, 1);
            // console.log(itemsIndex);

            const question1 = document.querySelector(".domanda-1");
            if (question1) { question1.remove(); }

            questionDiv.classList.add("hide");
            questionOne();
        });

        nextBtn.addEventListener("click", function (event) {
            if (selectedItems.length < 2) {
                return;
            }
            questionDiv.classList.add("hide");
            questionThree();
            window.scrollTo(0,0);
        });
    }
}

function questionThree(title = questionData[2]?.title, description = questionData[2]?.description) {
    if (outputBody) {
        const question2 = document.querySelector(".domanda-2");
        if (question2) {
            question2.remove();
        }

        const questionDiv = document.createElement("div");
        questionDiv.classList.add("domande", "domanda-3");
        const h2 = document.createElement("h2");
        const p = document.createElement("p");
        const questionsList = document.createElement("ul");
        const buttonWrapper = document.createElement("div");
        const prevBtn = document.createElement("button");
        const nextBtn = document.createElement("button");

        // Add classes or IDs
        h2.classList.add("titolo-domanda");
        p.classList.add("descrizione-domanda");
        questionsList.classList.add("elenco-domande");
        buttonWrapper.classList.add("contenitore-domande");
        prevBtn.id = "domandaPrecedente";
        nextBtn.id = "domandaSuccessiva";
        nextBtn.disabled = true;
        nextBtn.classList.add("disabled");

        // Add text
        h2.innerText = title === "" ? "Nessun titolo!" : title;
        p.innerText = description === "" ? "" : description;
        prevBtn.innerText = "Indietro";
        nextBtn.innerText = "Avanti";

        // Append elements
        questionDiv.appendChild(h2);
        questionDiv.appendChild(p);

        for (let i = 0; i < questionData[2].questions.length; i++) {
            const li = document.createElement("li");
            li.innerText = questionData[2].questions[i];
            questionsList.appendChild(li);
        }

        buttonWrapper.appendChild(prevBtn);
        buttonWrapper.appendChild(nextBtn);
        questionDiv.appendChild(questionsList);
        questionDiv.appendChild(buttonWrapper);

        // Append to question App
        outputBody.appendChild(questionDiv);

        // Add event listener
        const listItems = document.querySelectorAll(".domanda-3 .elenco-domande li");
        

        listItems.forEach((item, pos) => {
            item.addEventListener("click", function (event) {
                listItems.forEach((item) => item.classList.remove("active"));

                item.classList.add("active");

                selectedItems.splice(2, 1);
                selectedItems.push(event.target.innerText);

                itemsIndex.splice(2, 1);
                itemsIndex.push(pos);

                if (selectedItems.length > 2) {
                    nextBtn.disabled = false;
                    nextBtn.classList.remove("disabled");
                }
            });
        });

        prevBtn.addEventListener("click", function (event) {
            selectedItems.splice(2, 1);
            itemsIndex.splice(2, 1);
            // console.log(itemsIndex);

            const question3 = document.querySelector(".domanda-3");
            if (question3) { question3.remove();}

            questionTwo();
        });

        nextBtn.addEventListener("click", function (event) {
            if (selectedItems.length < 3) {   
                return;
            }

            questionDiv.classList.add("hide");
            lastQuestion();
            window.scrollTo(0,0);
        });
    }
}

async function lastQuestion() {

    let q1 = itemsIndex[0];
    let q2 = itemsIndex[1];
    let q3 = itemsIndex[2];

    let product_handle = "";

    if (q3 == 1 || q3 == 2) {
        // Se Q3 = "solo birre senza glutine"
        if (q3 == 1) { product_handle= 'box-gluten-free'; }
        // Se Q3 = "solo birre analcoliche"
        if (q3 == 2) { product_handle= 'box-alcohol-free'; }
    } 

    // Se Q2 = "Focus su uno stile specifico" e Q1 = "birre luppolate e amare"
    else if (q2 == 1 && q1 == 0) { product_handle= 'box-luppoli-americani'}
    // Se Q2 = "Focus su uno stile specifico" e Q1 = "birre maltate e dolci"
    else if (q2 == 1 && q1 == 1) { product_handle= 'box-da-12-tutte-tripel'}
    // Se Q2 = "Focus su uno stile specifico" e Q1 = "birre tostate e corpose"
    else if (q2 == 1 && q1 == 2) { product_handle= 'box-da-12-black-beers'}
    // Se Q2 = "Focus su uno stile specifico" e Q1 = "birre leggere e rinfrescanti"
    else if (q2 == 1 && q1 == 3) { product_handle= 'box-basse-fermentazioni'}
    // Se Q2 = "È un regalo" e Q1 = "luppolate/amare" 
    else if (q1 == 0 && q2 == 2) { product_handle= 'box-regalo-birre-amare'}
    // Se Q2 = "È un regalo" e Q1 = "maltate/dolci" 
    else if (q1 == 1 && q2 == 2) { product_handle= 'box-regalo-birre-dolci'}
    // Fallback
    else { product_handle= 'box-da-12-starter-pack' }

    try {
        let product = await productRecommendApi(product_handle);
        lastProductUI(product);
    } catch (error) {
        console.error("Errore durante il caricamente dei suggerimenti:", error);
    }
}

function lastProductUI(product) {
    if (outputBody) {
        
        const h2 = document.createElement("h2");
        h2.innerText = "Potresti provare:"
        h2.classList.add("titolo");

        const productDivContainer = document.createElement("div");
        productDivContainer.classList.add("risultati");

        const { title, price, url, available, id, featured_image, variants, handle } = product;

        //console.log(product);

        const checkoutproductHandle = variants[0].id;
        const productHandle = handle;

        const productDiv = document.createElement("div");
        productDiv.classList.add("prodotto");

        if (available) {
            const a = document.createElement("a");
            a.href = url;
            a.target = "_blank";
            a.rel = "noopener noreferrer";
            a.classList.add("link-prodotto");
            a.id = id;


            const h3 = document.createElement("h3");
            h3.innerText = title;
            h3.classList.add("titolo-prodotto");


            const img = document.createElement("img");
            img.src = featured_image;
            img.alt = title;
            img.classList.add("immagine-prodotto");


            const p = document.createElement("p");
            p.innerText = price;
            p.classList.add("prezzo-prodotto");


            const buyNowButton = document.createElement("a");
            buyNowButton.classList.add("pulsante-prodotto");
            buyNowButton.target = "_blank";
            
            //pagina prodotto
            buyNowButton.href = `${window.Shopify.routes.root}products/${productHandle}`;
            
            //checkout diretto ma non funziona per plugin codice fiscale 
            //buyNowButton.href = `${window.Shopify.routes.root}cart/${checkoutproductHandle}:1`;
            
            buyNowButton.innerText = "Scopri di più";

            a.appendChild(h3); 
            a.appendChild(img); 
            //a.appendChild(p); 
            a.appendChild(buyNowButton);

            productDiv.appendChild(a);

            productDivContainer.appendChild(productDiv);

            // Append to question App
            outputBody.appendChild(h2);
            outputBody.appendChild(productDivContainer);
        }
    }
}

async function productRecommendApi(handle) {
    if (!handle) {
      console.error("Manca l'handle del prodotto");
      return Promise.reject("Manca l'handle del prodotto");
    }

    const url = window.Shopify.routes.root + `products/${handle}.js`;

    try {
      const response = await fetch(url);
      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Errore durante il caricamento dei prodotti:", error);
      return Promise.reject(error);
    }
  }

document.addEventListener("DOMContentLoaded", function () {
  window.questions = questions || {};
  welcomeScreen();
});